import glamorous from "glamorous";
import Section from "../Section";

const Funnel = glamorous(Section)(({ theme, glam = {} }) => ({
  background: "linear-gradient(to right, #243B55, #141E30)",
  color: "white",
  display: "flex",
  flexDirection: glam.flexDirection || "row",
  [theme.main.mediaQueries.mobileTablet]: {
    flexDirection: "column",
    textAlign: "center",
    "&> *:not(:last-child)": {
      marginBottom: "1.5rem",
      padding: 0
    }
  }
}));

const FunnelTitle = glamorous.h1({
  color: "#fff",
  margin: 0
});

export { Funnel, FunnelTitle };



// WEBPACK FOOTER //
// ./src/components/Funnel/index.js